
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 65 70"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"fill":"currentColor","d":"M58.672 5.144V2.461A2.466 2.466 0 0056.207 0h-2.04a2.466 2.466 0 00-2.464 2.46v2.63l-15.887.003V2.464a2.466 2.466 0 00-2.464-2.46h-2.04a2.466 2.466 0 00-2.464 2.46v2.63H12.965v-2.63A2.466 2.466 0 0010.5.004H8.46a2.466 2.466 0 00-2.465 2.46v2.731A7.127 7.127 0 000 12.25v50.595C0 66.791 3.214 70 7.166 70h50.668C61.786 70 65 66.79 65 62.844l-.007-50.599c.003-3.658-2.768-6.681-6.322-7.1zm-5.097-2.68c0-.328.267-.591.592-.591h2.04c.33 0 .593.266.593.591v7.127a.592.592 0 01-.593.592h-2.04a.592.592 0 01-.592-.592V2.464zm-22.855 0c0-.328.267-.591.592-.591h2.04c.33 0 .593.266.593.591v7.127a.592.592 0 01-.593.592h-2.04a.592.592 0 01-.592-.592V2.464zm-22.855 0c0-.328.267-.591.592-.591h2.04c.33 0 .593.266.593.591v7.127a.592.592 0 01-.593.592h-2.04a.592.592 0 01-.592-.592V2.464zm-1.872 4.63v2.493a2.466 2.466 0 002.464 2.461h2.04a2.466 2.466 0 002.465-2.46v-2.63h15.886v2.63a2.466 2.466 0 002.464 2.46h2.04a2.466 2.466 0 002.465-2.46v-2.63h15.886v2.63a2.466 2.466 0 002.465 2.46h2.04a2.466 2.466 0 002.464-2.46V7.031c2.52.405 4.453 2.585 4.453 5.213v9.095l-61.255.003V12.25a5.266 5.266 0 014.124-5.155h-.001zM57.83 68.127H7.163c-2.918 0-5.294-2.37-5.294-5.286l.003-39.628h61.252v39.628c0 2.913-2.376 5.286-5.294 5.286z"}}),_c('path',{attrs:{"stroke":"#BF9C5F","stroke-width":"2","d":"M53.703 40.855a6.005 6.005 0 00-8.43.005l-.636.627-.695-.561a6.008 6.008 0 00-8.02.425 6.003 6.003 0 00-.446 7.98l9.094 9.094 9.13-9.129a6.005 6.005 0 00.003-8.44zm0 0a5.72 5.72 0 00-.004-.004l.009.009a6.333 6.333 0 00-.005-.005z"}})])])
          )
        }
      }
    